import { registerQuery } from 'data-fetching-client';
import fetchFormPermissions from 'ui-forms-components/api/permissions/fetchFormPermissions';
export const GET_FORM_PERMISSIONS_FIELD_NAME = 'getFormPermissions';
export const GET_FORM_PERMISSIONS = registerQuery({
  fieldName: GET_FORM_PERMISSIONS_FIELD_NAME,
  args: ['formGuid'],
  fetcher: ({
    formGuid
  }) => {
    return fetchFormPermissions(formGuid);
  }
});